class RouteSuggestionRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteSuggestion";

    super(entityName);

    if (!App.Forms.RouteSuggestion) {
      App.Forms.RouteSuggestion = {
        table: null,
        dataProvider: null,
        layout: {},
        dataMapper: null
      };
    }
  }

  renderGrid = (suggestions, pendingOrder) => {
    const entity = "RouteSuggestion";
    const ajax = new Monet.Ajax();
    
    ajax.url = "form/RouteSuggestion/index";
    ajax.success = data => {
      if (data) {
        App.Forms.RouteSuggestion.layout.index = data;
        const label = "Greenmile.RouteSuggestion.pendingOrder";
        const layout = App.Forms.RouteSuggestion.layout.index;

        let title = "";
        let subtitle = "";

        if (pendingOrder) {
          const location = pendingOrder.get("location");

          title = `${Monet.I18n.getResourcesByKey(label)} ${
            location.description
          }`;
          subtitle = Monet.I18n.getResourcesByKey('Greenmile.RouteSuggestion.gridSubtitle');
        }

        const container = `#${entity}`;
        const divContainer = document.querySelector(container);

        divContainer.innerHTML = Greenmile.Templates.templateGridListTemplate({
          title,
          subtitle
        });

        const dataMapper = new Monet.Builder.DataMapper();
        dataMapper.setEntity("RouteSuggestion");
        dataMapper.build(null, layout);
        
        new Greenmile.RouteSuggestion.Grid().show(suggestions, pendingOrder);
      }
    };
    ajax.error = response => {
      Monet.Configurations.errorNotification(null, response);
    };
    ajax.send();
  };
}

App.Routers.RouteSuggestion = RouteSuggestionRouter;
